import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../shared/BaseFragment";
import {Page} from "@/libwyze-shared/types";

export type BaseModuleMainProps = BaseFragmentProps & {
  modulePath?: string,
}

export type BaseModuleMainState = BaseFragmentState & {}

export abstract class BaseModuleMain<P extends BaseModuleMainProps = BaseModuleMainProps, S extends BaseModuleMainState = BaseModuleMainState> extends BaseFragment<P, S> {

  async onPracticePageLoaded(page: Page): Promise<void> {
  }
}